import { render, staticRenderFns } from "./detail_five.vue?vue&type=template&id=2bb5cfa9&scoped=true&"
import script from "./detail_five.vue?vue&type=script&lang=js&"
export * from "./detail_five.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5cfa9",
  null
  
)

export default component.exports